import React, { Component } from 'react'
import {
  Container,
  Grid,
  Header,
  Image,
  Loader
} from 'semantic-ui-react'
import {connect} from 'react-redux';

import RegisterStepper from './register_stepper';
import FormsRegisterIdentity from '../../component/forms/register/register_identity/forms_register_identity';
import FormsConfirmIdentity from '../../component/forms/register/confirm_identity/forms_confirm_identity';
import FormsRegisterEmail from '../../component/forms/register/register_email/forms_register_email';
import FormsRegisterOtp from '../../component/forms/register/register_otp/forms_register_otp';
import FormsRegisterPassword from '../../component/forms/register/register_password/forms_register_password';
import FormsRegisterTou from '../../component/forms/register/forms_register_tou';
import FormsRegisterComplete from '../../component/forms/register/forms_register_complete';
import FormsRegisterBankAccount from '../../component/forms/register/bank_account/form_register_bank';

import GroupCareLogoHorImage from './groupcare_logo_hor.jpg';

import {
    registerVerifyIdentity,
    registerGenerateOTPEmail,
    registerVerifyOTPEmail,
    registerActivateAccount,
    getAppConfigCountryCodes,
    getBankOptions
} from '../../actions'

class RegisterPage extends Component {

    state = {
        stepIndex: 1,
        identifier: null,
        email: null,
        newPassword: null,
        name: null,
        contactNo: null,
        contactNoCountryCode: null,
        hasVerifiedIdentity: false,
        requireRegistrationEmail: false,
        emailEditable: false,
        OTPtype: 'EMAIL',
    }

    componentDidMount() {
        this.props.getAppConfigCountryCodes();
        this.props.getBankOptions();
    }

    renderStateForm() {
        if (this.state.stepIndex === 1) {
            return <FormsRegisterTou updateStepIndex={this.updateStepIndex.bind(this)} />
        } else if (this.state.stepIndex === 2 && this.state.hasVerifiedIdentity === false) {
            return (
                <FormsRegisterIdentity
                    updateStepIndex={this.updateStepIndex.bind(this)}
                    registerVerifyIdentity={this.props.registerVerifyIdentity}
                />
            );
        } else if (this.state.stepIndex === 2 && this.state.hasVerifiedIdentity === true) {
            return (
                <FormsConfirmIdentity
                    updateStepIndex={this.updateStepIndex.bind(this)}
                    name={this.state.name}
                    contactNo={this.state.contactNo}
                    contactNoCountryCode={this.state.contactNoCountryCode}
                    identifier={this.state.identifier}
                    email={this.state.email}
                    countryCodes={this.props.countryCodes}
                    requireRegistrationEmail={this.state.requireRegistrationEmail}
                    emailEditable={this.state.emailEditable}
                    registerGenerateOTPEmail={this.props.registerGenerateOTPEmail}
                />
            );
        } else if (this.state.stepIndex === 3) {
            return (
                <FormsRegisterEmail
                    updateStepIndex={this.updateStepIndex.bind(this)}
                    name={this.state.name}
                    contactNo={this.state.contactNo}
                    identifier={this.state.identifier}
                    emailProvided={this.state.email}
                    requireRegistrationEmail={this.state.requireRegistrationEmail}
                    emailEditable={this.state.emailEditable}
                    contactNoCountryCode={this.state.contactNoCountryCode}
                    registerGenerateOTPEmail={this.props.registerGenerateOTPEmail}
                />
            );
        } else if (this.state.stepIndex === 4) {
            return (
                <FormsRegisterOtp
                    updateStepIndex={this.updateStepIndex.bind(this)}
                    identifier={this.state.identifier}
                    name={this.state.name}
                    email={this.state.email}
                    OTPtype={this.state.OTPtype}
                    registerVerifyOTPEmail={this.props.registerVerifyOTPEmail}
                />
            );
        } else if (this.state.stepIndex === 5) {
            return (
                <FormsRegisterPassword
                    updateStepIndex={this.updateStepIndex.bind(this)}
                    identifier={this.state.identifier}
                    name={this.state.name}
                    email={this.state.email}
                    contactNo={this.state.contactNo}
                    contactNoCountryCode={this.state.contactNoCountryCode}
                    registerActivateAccount={this.props.registerActivateAccount}
                />
            );
        } else if (this.state.stepIndex === 6) {

            return  <FormsRegisterBankAccount
                        updateStepIndex={this.updateStepIndex.bind(this)}
                        identifier={this.state.identifier}
                        name={this.state.name}
                        email={this.state.email}
                        contactNo={this.state.contactNo}
                        contactNoCountryCode={this.state.contactNoCountryCode}
                        registerActivateAccount={this.props.registerActivateAccount}
                        password={this.state.password}
                        bankList={this.props.bankList}
                    />
        } else if (this.state.stepIndex === 7) {
            return <FormsRegisterComplete updateStepIndex={this.updateStepIndex.bind(this)} />
        }
    }

    updateStepIndex(newStepIndex, data) {
        console.log({stepIndex: newStepIndex, ...data});
        this.setState({stepIndex: newStepIndex, ...data});
    }

    render() {
        if (this.props.countryCodes.length === 0) {
            return <Loader active />
        }
        return (
            <Container style={{ paddingTop: '2.5em', paddingBottom: '2.5em' }}>

                <Image src={GroupCareLogoHorImage} size="medium"/>

                <Header as='h2' block>
                    Register Your Account
                </Header>

                <Grid centered columns={3}>
                    <Grid.Column>
                        <RegisterStepper stepIndex={this.state.stepIndex} />
                    </Grid.Column>
                <Grid.Column width={10}>
                    {this.renderStateForm()}
                </Grid.Column>

                </Grid>
            </Container>
        );
    }
}

const mapStateToProps = state => {
        console.log(state);
    return {
        countryCodes: state.appConfig.countryCodes,
        bankList: state.appConfig.bankList
    };
}

export default connect(mapStateToProps, {
    registerVerifyIdentity,
    registerGenerateOTPEmail,
    registerVerifyOTPEmail,
    registerActivateAccount,
    getAppConfigCountryCodes,
    getBankOptions
})(RegisterPage);
